module.exports = __webpack_public_path__ + "static/media/ic_education_material.e98808f5.png";